/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeletedSkill = {
  id: string;
  deleted: boolean;
  object?: "skill.deleted" | undefined;
};

/** @internal */
export const DeletedSkill$inboundSchema: z.ZodType<
  DeletedSkill,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  object: z.literal("skill.deleted").default("skill.deleted"),
});
/** @internal */
export type DeletedSkill$Outbound = {
  id: string;
  deleted: boolean;
  object: "skill.deleted";
};

/** @internal */
export const DeletedSkill$outboundSchema: z.ZodType<
  DeletedSkill$Outbound,
  z.ZodTypeDef,
  DeletedSkill
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
  object: z.literal("skill.deleted").default("skill.deleted" as const),
});

export function deletedSkillToJSON(deletedSkill: DeletedSkill): string {
  return JSON.stringify(DeletedSkill$outboundSchema.parse(deletedSkill));
}
export function deletedSkillFromJSON(
  jsonString: string,
): SafeParseResult<DeletedSkill, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeletedSkill$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeletedSkill' from JSON`,
  );
}
